import { useState } from 'react'
import { AppShell } from '../components/AppShell'
import { SettingsSidebar } from './SettingsPage'

interface NotifPref {
  key: string; label: string; description: string
  email: boolean; inApp: boolean; push: boolean
}

const DEFAULTS: NotifPref[] = [
  { key: 'bet_settled',    label: 'Bet settled',           description: 'When one of your bets is graded.',                email: false, inApp: true,  push: true },
  { key: 'dd_warning',     label: 'Drawdown warning',      description: 'When you are within 1% of the DD floor.',         email: true,  inApp: true,  push: true },
  { key: 'phase_passed',   label: 'Phase passed',          description: 'When you advance to the next phase.',             email: true,  inApp: true,  push: true },
  { key: 'payout_status',  label: 'Payout status changes', description: 'Approved / paid / rejected.',                     email: true,  inApp: true,  push: false },
  { key: 'kyc_status',     label: 'KYC status changes',    description: 'Approved or additional info requested.',          email: true,  inApp: true,  push: false },
  { key: 'marketing',      label: 'Product updates',       description: 'New features and tier changes.',                  email: false, inApp: false, push: false },
]

function Toggle({ checked, onChange }: { checked: boolean; onChange: (v: boolean) => void }) {
  return (
    <label className="toggle">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <span className="toggle__slider" />
    </label>
  )
}

export function SettingsNotificationsPage() {
  const [prefs, setPrefs] = useState(DEFAULTS)
  const [saved, setSaved] = useState(false)

  const update = (key: string, field: 'email' | 'inApp' | 'push', value: boolean) => {
    setPrefs((cur) => cur.map((p) => (p.key === key ? { ...p, [field]: value } : p)))
    setSaved(false)
  }

  return (
    <AppShell page="settings" breadcrumb={<span className="topbar__breadcrumb-current">Settings · Notifications</span>}>
      <header className="page-header">
        <div className="page-header__main">
          <p className="page-header__eyebrow"><span>Account</span></p>
          <h1 className="page-header__title">Notifications</h1>
          <p className="page-header__subtitle">Pick how you want to be reached for each event type.</p>
        </div>
      </header>

      <div className="settings-layout">
        <SettingsSidebar active="notifications" />

        <div className="settings-content">
          <section className="settings-card">
            <header className="settings-card__header">
              <div className="settings-card__title-group">
                <h2 className="settings-card__title">Channels per event</h2>
                <p className="settings-card__description">In-app notifications always remain available; email and push are optional.</p>
              </div>
            </header>
            <div className="settings-card__body">
              <div className="table-wrap">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Event</th>
                      <th style={{ textAlign: 'center' }}>In-app</th>
                      <th style={{ textAlign: 'center' }}>Email</th>
                      <th style={{ textAlign: 'center' }}>Push</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prefs.map((p) => (
                      <tr key={p.key}>
                        <td>
                          <div style={{ fontWeight: 600 }}>{p.label}</div>
                          <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>{p.description}</div>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <Toggle checked={p.inApp} onChange={(v) => update(p.key, 'inApp', v)} />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <Toggle checked={p.email} onChange={(v) => update(p.key, 'email', v)} />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <Toggle checked={p.push} onChange={(v) => update(p.key, 'push', v)} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="save-bar" style={{ marginTop: 'var(--space-4)' }}>
                <div className="save-bar__status">
                  {saved && <span style={{ color: 'var(--color-success-text)' }}>Preferences saved (local-only — backend wiring pending).</span>}
                </div>
                <div className="save-bar__actions">
                  <button type="button" className="btn btn--primary" onClick={() => setSaved(true)}>Save preferences</button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </AppShell>
  )
}
